// extracted by mini-css-extract-plugin
export default {"container__title":"modal-confirmation_container__title__u1CoT","container__buttons":"modal-confirmation_container__buttons__JnZQd"};